import axios from "axios";
import { Auth } from "aws-amplify";

// const api = axios.create({
//   baseURL:
//     process.env.NODE_ENV === "development"
//       ? "http://192.168.1.47:1337"
//       : // "https://qpkajybyb2.execute-api.ap-southeast-1.amazonaws.com/dev"
//         "https://qpkajybyb2.execute-api.ap-southeast-1.amazonaws.com/dev",
// });

const api = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? "https://qpkajybyb2.execute-api.ap-southeast-1.amazonaws.com/dev"
      : "https://qpkajybyb2.execute-api.ap-southeast-1.amazonaws.com/dev",
});

// const requestInterceptors = async (configAxios) => {
//   try {
//     const session = await Auth?.currentSession();
//     if (session) {
//       configAxios.headers = {
//         ...configAxios.headers,
//         Authorization: `Bearer ${session.getAccessToken().getJwtToken()}`,
//       };
//     }
//     return configAxios;
//   } catch (error) {
//     return configAxios;
//   }
// };

// api.interceptors.request.use(requestInterceptors);

export default api;
